import { Card, CardBody, Col } from "reactstrap";
import { GoogleMap, useJsApiLoader, } from "@react-google-maps/api";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Polygons } from "../../../../Constant";
import { PolylineCenter, PolylineContainerStyle } from "../../../../Data/Maps";

const PolylinesMapComp = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAjeJEPREBQFvAIqDSZliF0WjQrCld-Mh0",
  });

  return (
    <Col lg="6" md="12">
      <Card>
        <CommonCardHeader title={Polygons} />
        <CardBody>
          <div className="map-js-height">
            <div id="gmap-simple" className="map-block">
              {isLoaded ? (
                <GoogleMap
                  mapContainerStyle={PolylineContainerStyle}
                  center={PolylineCenter}
                  zoom={10}
                ></GoogleMap>
              ) : (
                "loading"
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PolylinesMapComp;
